/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Acted Core API
 * Core backend API.
 * OpenAPI spec version: 1.0.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  ArchiveDocumentCreateFromUploadRequestRequest,
  ArchiveDocumentDeleteMultipleRequest,
  ArchiveDocumentDeleteMultipleResponse,
  ArchiveDocumentDeletePageRequestRequest,
  ArchiveDocumentDetail,
  ArchiveDocumentDetailRequest,
  ArchiveDocumentSplitPdfRequestRequest,
  ArchiveDocumentUpdateMultipleRequest,
  ArchiveDocumentUpdateMultipleResponse,
  ArchiveDocumentsGetAuditLogListParams,
  ArchiveDocumentsListParams,
  ExportRequestRequest,
  LongRunningJob,
  PaginatedArchiveDocumentListItemList,
  PaginatedLogEntryList,
  PatchedArchiveDocumentDetailRequest,
  PlayTransitionRequestRequest
} from '../model';

import {
  environment
} from 'environments/environment';



import { filterParams, HttpClientBodyOptions, HttpClientEventOptions, HttpClientObserveOptions, HttpClientResponseOptions } from '../httpClientOptions';

@Injectable({ providedIn: 'root' })
export class ArchiveDocumentsService {
  private readonly http = inject(HttpClient);
 list<TData = PaginatedArchiveDocumentListItemList>(params?: ArchiveDocumentsListParams, options?: HttpClientBodyOptions): Observable<TData>;
 list<TData = PaginatedArchiveDocumentListItemList>(params?: ArchiveDocumentsListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 list<TData = PaginatedArchiveDocumentListItemList>(params?: ArchiveDocumentsListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  list<TData = PaginatedArchiveDocumentListItemList>(
    params?: ArchiveDocumentsListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/archive-documents/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/archive-documents/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `${environment.apiRoot}/api/archive-documents/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
 retrieve<TData = ArchiveDocumentDetail>(uuid: string, options?: HttpClientBodyOptions): Observable<TData>;
 retrieve<TData = ArchiveDocumentDetail>(uuid: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 retrieve<TData = ArchiveDocumentDetail>(uuid: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  retrieve<TData = ArchiveDocumentDetail>(
    uuid: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 update<TData = ArchiveDocumentDetail>(uuid: string,
    archiveDocumentDetailRequest?: ArchiveDocumentDetailRequest, options?: HttpClientBodyOptions): Observable<TData>;
 update<TData = ArchiveDocumentDetail>(uuid: string,
    archiveDocumentDetailRequest?: ArchiveDocumentDetailRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 update<TData = ArchiveDocumentDetail>(uuid: string,
    archiveDocumentDetailRequest?: ArchiveDocumentDetailRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  update<TData = ArchiveDocumentDetail>(
    uuid: string,
    archiveDocumentDetailRequest?: ArchiveDocumentDetailRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/`,
      archiveDocumentDetailRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/`,
      archiveDocumentDetailRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.put<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/`,
      archiveDocumentDetailRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 partialUpdate<TData = ArchiveDocumentDetail>(uuid: string,
    patchedArchiveDocumentDetailRequest?: PatchedArchiveDocumentDetailRequest, options?: HttpClientBodyOptions): Observable<TData>;
 partialUpdate<TData = ArchiveDocumentDetail>(uuid: string,
    patchedArchiveDocumentDetailRequest?: PatchedArchiveDocumentDetailRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 partialUpdate<TData = ArchiveDocumentDetail>(uuid: string,
    patchedArchiveDocumentDetailRequest?: PatchedArchiveDocumentDetailRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  partialUpdate<TData = ArchiveDocumentDetail>(
    uuid: string,
    patchedArchiveDocumentDetailRequest?: PatchedArchiveDocumentDetailRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/`,
      patchedArchiveDocumentDetailRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/`,
      patchedArchiveDocumentDetailRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/`,
      patchedArchiveDocumentDetailRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 destroy<TData = void>(uuid: string, options?: HttpClientBodyOptions): Observable<TData>;
 destroy<TData = void>(uuid: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 destroy<TData = void>(uuid: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  destroy<TData = void>(
    uuid: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * delete a page from the ArchiveDocument PDF
 */
 deletePage<TData = ArchiveDocumentDetail>(uuid: string,
    archiveDocumentDeletePageRequestRequest: ArchiveDocumentDeletePageRequestRequest, options?: HttpClientBodyOptions): Observable<TData>;
 deletePage<TData = ArchiveDocumentDetail>(uuid: string,
    archiveDocumentDeletePageRequestRequest: ArchiveDocumentDeletePageRequestRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deletePage<TData = ArchiveDocumentDetail>(uuid: string,
    archiveDocumentDeletePageRequestRequest: ArchiveDocumentDeletePageRequestRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deletePage<TData = ArchiveDocumentDetail>(
    uuid: string,
    archiveDocumentDeletePageRequestRequest: ArchiveDocumentDeletePageRequestRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/delete-page/`,
      archiveDocumentDeletePageRequestRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/delete-page/`,
      archiveDocumentDeletePageRequestRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/delete-page/`,
      archiveDocumentDeletePageRequestRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Download file content, probably to the PDFTron Archives v2 client.
 *
 * Note that this function is a work in progress: the http partial download works but requires
 *   us to post-process the PDFs "linearize" in order to be useful.
 */
 download(uuid: string, options?: HttpClientBodyOptions): Observable<Blob>;
 download(uuid: string, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 download(uuid: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  download(
    uuid: string, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    if (options?.observe === 'events') {
      return this.http.get(
      `${environment.apiRoot}/api/archive-documents/${uuid}/download/`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.get(
      `${environment.apiRoot}/api/archive-documents/${uuid}/download/`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.get(
      `${environment.apiRoot}/api/archive-documents/${uuid}/download/`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    ) as Observable<Blob>;
  }
/**
 * return a list of AuditLogEntries for the given object
 */
 getAuditLog<TData = PaginatedLogEntryList>(uuid: string,
    params?: ArchiveDocumentsGetAuditLogListParams, options?: HttpClientBodyOptions): Observable<TData>;
 getAuditLog<TData = PaginatedLogEntryList>(uuid: string,
    params?: ArchiveDocumentsGetAuditLogListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getAuditLog<TData = PaginatedLogEntryList>(uuid: string,
    params?: ArchiveDocumentsGetAuditLogListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getAuditLog<TData = PaginatedLogEntryList>(
    uuid: string,
    params?: ArchiveDocumentsGetAuditLogListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/get-audit-log/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/get-audit-log/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/get-audit-log/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * Play a workflow transition on this instance, moving it to the transition's target state.
 */
 playTransition<TData = ArchiveDocumentDetail>(uuid: string,
    playTransitionRequestRequest: PlayTransitionRequestRequest, options?: HttpClientBodyOptions): Observable<TData>;
 playTransition<TData = ArchiveDocumentDetail>(uuid: string,
    playTransitionRequestRequest: PlayTransitionRequestRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 playTransition<TData = ArchiveDocumentDetail>(uuid: string,
    playTransitionRequestRequest: PlayTransitionRequestRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  playTransition<TData = ArchiveDocumentDetail>(
    uuid: string,
    playTransitionRequestRequest: PlayTransitionRequestRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/play-transition/`,
      playTransitionRequestRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/play-transition/`,
      playTransitionRequestRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/play-transition/`,
      playTransitionRequestRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * split this ArchiveDocument into 2 documents, cloning any attributes that might exist
 */
 splitPdf<TData = ArchiveDocumentDetail>(uuid: string,
    archiveDocumentSplitPdfRequestRequest: ArchiveDocumentSplitPdfRequestRequest, options?: HttpClientBodyOptions): Observable<TData>;
 splitPdf<TData = ArchiveDocumentDetail>(uuid: string,
    archiveDocumentSplitPdfRequestRequest: ArchiveDocumentSplitPdfRequestRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 splitPdf<TData = ArchiveDocumentDetail>(uuid: string,
    archiveDocumentSplitPdfRequestRequest: ArchiveDocumentSplitPdfRequestRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  splitPdf<TData = ArchiveDocumentDetail>(
    uuid: string,
    archiveDocumentSplitPdfRequestRequest: ArchiveDocumentSplitPdfRequestRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/split-pdf/`,
      archiveDocumentSplitPdfRequestRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/split-pdf/`,
      archiveDocumentSplitPdfRequestRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${environment.apiRoot}/api/archive-documents/${uuid}/split-pdf/`,
      archiveDocumentSplitPdfRequestRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Create a new ArchiveDocument from an incoming upload.
 *
 * This view is used for an initial upload but also when the user 'splits' an existing document.
 * In the case of a split document the metadata of the original document is copied to the new document.
 */
 createFromUpload<TData = ArchiveDocumentDetail>(archiveDocumentCreateFromUploadRequestRequest: ArchiveDocumentCreateFromUploadRequestRequest, options?: HttpClientBodyOptions): Observable<TData>;
 createFromUpload<TData = ArchiveDocumentDetail>(archiveDocumentCreateFromUploadRequestRequest: ArchiveDocumentCreateFromUploadRequestRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 createFromUpload<TData = ArchiveDocumentDetail>(archiveDocumentCreateFromUploadRequestRequest: ArchiveDocumentCreateFromUploadRequestRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  createFromUpload<TData = ArchiveDocumentDetail>(
    archiveDocumentCreateFromUploadRequestRequest: ArchiveDocumentCreateFromUploadRequestRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {const formData = new FormData();
if(archiveDocumentCreateFromUploadRequestRequest.originalUuid !== undefined) {
 formData.append(`originalUuid`, archiveDocumentCreateFromUploadRequestRequest.originalUuid);
 }
formData.append(`theFile`, archiveDocumentCreateFromUploadRequestRequest.theFile);

    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/archive-documents/create-from-upload/`,
      formData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/archive-documents/create-from-upload/`,
      formData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${environment.apiRoot}/api/archive-documents/create-from-upload/`,
      formData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Bulk-delete for multiple archive documents.
 *
 * This endpoint is protected by the `archive_user_can_assign_data` access policy, to prevent users from setting
 *   countries, places and types that they don't have access to.
 *
 * The endpoint performs its own per-document authorisation and will refuse any changes if a single document
 *   is unauthorised for the given user.
 */
 deleteMultiple<TData = ArchiveDocumentDeleteMultipleResponse>(archiveDocumentDeleteMultipleRequest?: ArchiveDocumentDeleteMultipleRequest, options?: HttpClientBodyOptions): Observable<TData>;
 deleteMultiple<TData = ArchiveDocumentDeleteMultipleResponse>(archiveDocumentDeleteMultipleRequest?: ArchiveDocumentDeleteMultipleRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteMultiple<TData = ArchiveDocumentDeleteMultipleResponse>(archiveDocumentDeleteMultipleRequest?: ArchiveDocumentDeleteMultipleRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteMultiple<TData = ArchiveDocumentDeleteMultipleResponse>(
    archiveDocumentDeleteMultipleRequest?: ArchiveDocumentDeleteMultipleRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/archive-documents/delete-multiple/`,
      archiveDocumentDeleteMultipleRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/archive-documents/delete-multiple/`,
      archiveDocumentDeleteMultipleRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${environment.apiRoot}/api/archive-documents/delete-multiple/`,
      archiveDocumentDeleteMultipleRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 _export<TData = LongRunningJob>(exportRequestRequest?: ExportRequestRequest, options?: HttpClientBodyOptions): Observable<TData>;
 _export<TData = LongRunningJob>(exportRequestRequest?: ExportRequestRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 _export<TData = LongRunningJob>(exportRequestRequest?: ExportRequestRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  _export<TData = LongRunningJob>(
    exportRequestRequest?: ExportRequestRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/archive-documents/export/`,
      exportRequestRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/archive-documents/export/`,
      exportRequestRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${environment.apiRoot}/api/archive-documents/export/`,
      exportRequestRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Bulk-update for multiple archive documents.
 *
 * Every field present in the request body is applied to every selected document: an explicit
 *   `null` clears the field and omitting a key leaves it untouched, i.e. the same semantics as
 *   `PATCH /api/archive-documents/{uuid}/`.
 *
 * This endpoint is protected by the `archive_user_can_assign_data` access policy, to prevent users from setting
 *   countries, places and types that they don't have access to.
 *
 * The endpoint performs its own per-document authorisation and will refuse any changes if a single document
 *   is unauthorised for the given user.
 */
 updateMultiple<TData = ArchiveDocumentUpdateMultipleResponse>(archiveDocumentUpdateMultipleRequest?: ArchiveDocumentUpdateMultipleRequest, options?: HttpClientBodyOptions): Observable<TData>;
 updateMultiple<TData = ArchiveDocumentUpdateMultipleResponse>(archiveDocumentUpdateMultipleRequest?: ArchiveDocumentUpdateMultipleRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 updateMultiple<TData = ArchiveDocumentUpdateMultipleResponse>(archiveDocumentUpdateMultipleRequest?: ArchiveDocumentUpdateMultipleRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  updateMultiple<TData = ArchiveDocumentUpdateMultipleResponse>(
    archiveDocumentUpdateMultipleRequest?: ArchiveDocumentUpdateMultipleRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/archive-documents/update-multiple/`,
      archiveDocumentUpdateMultipleRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/archive-documents/update-multiple/`,
      archiveDocumentUpdateMultipleRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${environment.apiRoot}/api/archive-documents/update-multiple/`,
      archiveDocumentUpdateMultipleRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};

